export default {
	proxyLabel: 'Enter maximum bid',
	proxyTooltip:
		'Set a maximum bid and we’ll automatically bid up on your behalf in increments of £{value} to secure the sale. If you’re the only bidder, your final bid will be set at the reserve price, or your maximum bid amount if your bid is lower than the reserve.',
};
